import React, { useEffect, useState } from "react";
import RffForm from "../components/finalForm/RffForm";
import InputWrapper from "../components/inputs/shared/InputWrapper";
import FileUploadField from "../components/inputs/FileUploadField";
import { isArray, isFunction, isNil, set, size } from "lodash";
import { Button } from "@mui/material";
import { UploadRounded } from "@mui/icons-material";
import { useBorrowerPortalHook } from "../hooks/useBorrowerPortalHook";

const PhotoIdentificationUploadForm = ({
  autoUpload = false,
  hideSuccessMsg = false,
  hideFileList = false,
  hideLoader = false,
  onSuccessFn,
  showFilesAfterAutoUpload,
}) => {
  const [files, setFiles] = useState(null);
  const [sent, setSent] = useState(false);
  const { loading, uploadBorrowerIdDocument } = useBorrowerPortalHook();

  const handleReset = () => {
    setFiles(null);
    setSent(false);
  };

  const handleUpload = (values) => {
    // Handle the upload logic here
    // console.log("Files uploaded");

    console.log("values", { values, files });
    setSent(true);

    uploadBorrowerIdDocument({
      files: files,
      hideSuccessMsg,
      onSuccessFn: (d) => {
        // setFiles(null);
        setSent(true);

        if (!showFilesAfterAutoUpload) {
          setFiles(null);
        }

        if (isFunction(onSuccessFn)) {
          onSuccessFn(d);
        }
      },
    });
    // uploadBorrowerIdDocument({
    //   data: values,
    //   onSuccessFn: () => {
    //     setShow(false);
    //   },
    // });
  };

  useEffect(() => {
    if (size(files) === 0 || (isNil(files) && sent)) {
      setSent(false);
    }

    if (size(files) === 1 && autoUpload && !sent) {
      handleUpload(files);
      return;
    }
  }, [files]);

  return (
    <RffForm
      // formSpy
      //
      suppressFooter
      onSubmit={handleUpload}
    >
      <InputWrapper label="Please upload a clear, front-side image of your driver’s license or passport.">
        <FileUploadField
          setFiles={setFiles}
          files={files}
          maxFiles={1}
          loading={hideLoader ? null : loading}
          hideFileList={hideFileList}
          docGroup={"Borrower Documents"}
          docType={"Photo Identification"}
        />
      </InputWrapper>

      {isArray(files) && !autoUpload ? (
        <Button
          startIcon={<UploadRounded />}
          size="large"
          hideIfEmpty
          //   loading={loading}
          onClick={() => handleUpload(files)}
          sx={{ mt: 1 }}
        >
          Upload Files
        </Button>
      ) : null}
    </RffForm>
  );
};

export default PhotoIdentificationUploadForm;
